import BaseAPI from './base';

class SupportService extends BaseAPI {
  postFile = async (file, progressCallback) => {
    const url = '/MediaFiles/Videos';

    return this.postFileWithProgress(url, file, progressCallback);
  }
}

export default new SupportService();
